<template>
  <div class="widget-heading pb-0 d-block">
    <div class="row">
      <!-- DUŻY EKRAN -->
      <div class="col-md-12 btn-group d-none d-md-flex">
        <Link :href="route('articles.template.index')" style="max-width: 200px;" class="btn btn-outline-primary" :class="{ 'btn-primary': isRouteActive('articles.template.index') }">Szablony artykułów</Link>
        <template v-if="isAdmin()">
          <Link :href="route('producents.index')" class="btn btn-outline-primary" :class="{ 'btn-primary': isRouteActive('producents.index') }">Producenci</Link>
          <Link :href="route('articles.units.index')" class="btn btn-outline-primary" :class="{ 'btn-primary': isRouteActive('articles.units.index') }">Jednostki artykułów</Link>
          <Link :href="route('articles.currencys.index')" class="btn btn-outline-primary" :class="{ 'btn-primary': isRouteActive('articles.currencys.index') }">Waluty</Link>
          <Link :href="route('customers-categories.index')" class="btn btn-outline-primary" :class="{ 'btn-primary': isRouteActive('customers-categories.index') }">Kategorie artykułów</Link>
          <Link :href="route('articleWarehouses.index')" class="btn btn-outline-primary" :class="{ 'btn-primary': isRouteActive('articleWarehouses.index') }">Magazyny</Link>
          <Link :href="route('articles.deleted.index')" class="btn btn-outline-primary" :class="{ 'btn-primary': isRouteActive('articles.deleted.index') }">Usunięte artykuły</Link>
        </template>
      </div>
      <!-- MAŁY EKRAN -->
      <div class="col-12 d-md-none">
        <div class="dropdown">
          <button class="btn btn-outline-primary dropdown-toggle w-100 d-flex justify-content-between" type="button" @click="toggleDropdown">{{ activeLabel }}</button>
          <div class="dropdown-menu w-100" :class="{ show: isDropdownOpen }">
            <Link
              :href="route('articles.template.index')"
              class="dropdown-item">Szablony artykułów</Link>
            <template v-if="isAdmin()">
              <Link :href="route('producents.index')" class="dropdown-item">Producenci</Link>
              <Link :href="route('articles.units.index')" class="dropdown-item">Jednostki artykułów</Link>
              <Link :href="route('articles.currencys.index')" class="dropdown-item">Waluty</Link>
              <Link :href="route('customers-categories.index')" class="dropdown-item">Kategorie artykułów</Link>
              <Link :href="route('articleWarehouses.index')" class="dropdown-item">Magazyny</Link>
              <Link :href="route('articles.deleted.index')" class="dropdown-item">Usunięte artykuły</Link>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, computed } from "vue";
import route from "../../../../../vendor/tightenco/ziggy/src/js/index.js";
import { usePermission } from "@/composables/resources/js/composables/permissions.js";

const { hasRole } = usePermission();

export default {
  data() {
    return {
      isDropdownOpen: false,
    };
  },

  computed: {
    activeLabel() {
      const labels = {
        "articles.template.index": "Szablony artykułów",
        "producents.index": "Producenci",
        "articles.units.index": "Jednostki artykułów",
        "articles.currencys.index": "Waluty",
        "customers-categories.index": "Kategorie artykułów",
        "articleWarehouses.index": "Magazyny",
        "articles.deleted.index": "Usunięte artykuły",
      };

      const current = route().current();
      return labels[current] || "Menu";
    }
  },

  methods: {
    toggleDropdown() {
      this.isDropdownOpen = !this.isDropdownOpen;
    },

    isRouteActive(name) {
      return route().current(name);
    },

    isAdmin() {
      return hasRole('ADMIN');
    }
  }
};
</script>
<style scoped>
.dropdown-menu {
  z-index: 99999 !important;
}
</style>